import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useState } from 'react';
import { LoadingState } from '@atlassian/notification-common/types';
export var useFetchService = function useFetchService(request, initialData, source) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _useState = useState({
      error: undefined,
      data: initialData,
      lastCallTimestamp: undefined,
      loadingState: LoadingState.INITIAL
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var fetchData = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
      var data, _options$logger;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setState(function (previousState) {
              return _objectSpread(_objectSpread({}, previousState), {}, {
                data: _objectSpread(_objectSpread({}, initialData), {}, {
                  args: args
                }),
                loadingState: LoadingState.LOADING,
                error: undefined,
                lastCallTimestamp: Date.now()
              });
            });
            _context.prev = 1;
            _context.next = 4;
            return request(args);
          case 4:
            data = _context.sent;
            setState(function (previousState) {
              return _objectSpread(_objectSpread({}, previousState), {}, {
                loadingState: LoadingState.COMPLETE,
                error: undefined,
                data: {
                  data: data,
                  args: args
                }
              });
            });
            return _context.abrupt("return", {
              data: data,
              args: args
            });
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.captureException(_context.t0, {
              source: source
            });
            setState(function (previousState) {
              return _objectSpread(_objectSpread({}, previousState), {}, {
                data: _objectSpread(_objectSpread({}, previousState.data), {}, {
                  args: args
                }),
                loadingState: LoadingState.ERROR,
                error: _context.t0
              });
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [request, options.logger, source, initialData]);
  return _objectSpread(_objectSpread({}, state), {}, {
    fetchData: fetchData
  });
};